let sessionStorage;
let localStorage;
let sessionStorageSupport = true;
let localStorageSupport = true;

try {
  sessionStorage = window.sessionStorage;
} catch (e) {
  sessionStorageSupport = false;
  console.warn('Session storage not available');
}

try {
  localStorage = window.localStorage;
} catch (e) {
  localStorageSupport = false;
  console.warn('Local storage not available');
}

function getSessionStorage(key) {
  if (sessionStorageSupport) {
    return sessionStorage.getItem(key);
  }
  return null;
}

function setSessionStorage(key) {
  if (sessionStorageSupport) {
    return sessionStorage.getItem(key);
  }
  return false;
}

function getLocalStorage(key) {
  if (localStorageSupport) {
    return localStorage.getItem(key);
  }
  return null;
}

function setLocalStorage(key) {
  if (localStorageSupport) {
    return localStorage.getItem(key);
  }
  return false;
}

module.exports = {
  storage: {
    session: {
      get: getSessionStorage,
      set: setSessionStorage,
    },
    local: {
      get: getLocalStorage,
      set: setLocalStorage,
    },
  },
};
